<template>
  <!-- 案件详情-功能区域 -->
  <div class="function-block">
    <el-card class="content-block">
      <div slot="header" class="clearfix">
        <span class="bold">功能区域</span>
      </div>
      <div class="item-block">
        <el-button
          v-if="checkPermission('资料:查看材料链接', permList)"
          :disabled="isCaseArchive"
          type="primary"
          size="small"
          @click="seeLinks"
        >
          查看材料链接
        </el-button>
        <el-button
          v-if="checkPermission('电子材料:发送邮件通知', permList)"
          :disabled="isCaseArchive"
          type="primary"
          size="small"
          @click="onNavsToSendEmail"
        >
          发送邮件通知
        </el-button>
        <el-button
          v-if="checkPermission('电子材料:生成调查表', permList)"
          :disabled="isCaseArchive"
          type="primary"
          size="small"
          @click="showdrawerbox('questionary01')"
        >
          生成调查表
        </el-button>
        <el-button
          v-if="checkPermission('电子材料:生成调查函', permList)"
          :disabled="isCaseArchive"
          type="primary"
          size="small"
          @click="showdrawerbox('questionary02')"
        >
          生成调查函
        </el-button>
        <template>
          <el-button
            v-if="
              checkPermission('设为特殊案件', permList) &&
                caseInfo.isSpecial == false
            "
            type="primary"
            size="small"
            @click="moveCase('toSpecial', '')"
          >
            设为特殊案件
          </el-button>

          <el-button
            v-if="
              checkPermission('设为普通案件', permList) &&
                caseInfo.isSpecial == true
            "
            type="primary"
            size="small"
            @click="moveCase('removeSpecial', '')"
          >
            设为普通案件
          </el-button>
        </template>
        <template
          v-if="
            caseInfo.flowCode != 103001 &&
              caseInfo.flowCode != 103501 &&
              caseInfo.isStation == false
          "
        >
          <el-button
            v-if="checkPermission('移到中转站', permList)"
            type="primary"
            size="small"
            @click="moveCase('toStation', '')"
          >
            移动到中转流程
          </el-button>
        </template>
        <el-button
          v-if="checkPermission('历史处理记录:查看', permList)"
          type="primary"
          size="small"
          @click="onShowHistoryDialog"
        >
          历史处理记录
        </el-button>
      </div>
    </el-card>

    <!-- 查看材料链接-弹出对话框 -->
    <el-dialog
      title="委托调查链接列表"
      width="50%"
      custom-class="c-p"
      :visible.sync="linkListdialog"
    >
      <el-table border :data="links">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column property="shareUrl" label="链接" />
        <el-table-column property="sharePwd" label="密码" width="100" />
        <el-table-column property="expireRemark" label="有效期" width="120" />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="createLinks">
          生成链接
        </el-button>
        <el-button size="small" @click="hideLinkListdialog">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 历史处理记录-弹出对话框 -->
    <el-dialog
      title="历史处理记录"
      :visible.sync="historyDialog"
      width="70%"
      custom-class="c-p"
    >
      <div>
        <div v-if="operationList.length == 0" class="none">
          <p>暂无</p>
        </div>
        <div v-else class="operat-list">
          <el-timeline :reverse="false" class="time-line">
            <el-timeline-item
              v-for="(item, index) in operationList"
              :key="index"
            >
              <div>
                {{ item.flow_name }}
                <span v-if="item.remark != null">
                  备注：
                  <span
                    class="el-link el-link--primary"
                    @click="showHistory(index)"
                  >查看</span>
                </span>
                <span v-if="item.ruleAnswerContent != null">
                  告知规则备注：
                  <span
                    class="el-link el-link--primary"
                    @click="showRuleAnswerContent(index)"
                  >查看</span>
                </span>
              </div>
              <p>
                {{ item.operate_time }}
                <span class="txt">操作账号: {{ item.account_number }}</span>
              </p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="onHideHistoryDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "FunctionalAreas",

  props: {
    // 案件详情
    caseInfo: {
      required: true,
      type: Object,
      default: () => {
        return {};
      },
    },
    // 操作历史记录列表
    operationList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      links: [], // 委托调查链接列表
      linkListdialog: false, // 查看材料链接-控制对话框的显示/隐藏

      historyDialog: false, // 历史处理记录-控制对话框的显示/隐藏
    };
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList,
    }),

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500
    }
  },

  methods: {
    /**
     * 查询分享链接-列表
     */
    async getLinks() {
      const _this = this;
      const { caseCode } = this.caseInfo;

      try {
        const { data: result } = await _this.axios.get(
          `/case-info/share-url/list/${caseCode}`
        );

        if (result && result.status === "000000") {
          _this.links = result.data;
        } else {
          _this.$alert(
            (result && result.message) || "服务器繁忙，请稍后重试",
            "提示"
          );
        }
      } catch (error) {
        console.log("查询分享链接-列表-请求失败", error);
      }
    },

    /**
     * 创建分享链接
     */
    async createLinks() {
      const _this = this;
      const { caseCode } = this.caseInfo;

      try {
        const { data: result } = await _this.axios.get(
          `/case-info/share-url/${caseCode}`
        );
        if (result && result.status === "000000") {
          _this.getLinks();
        } else {
          _this.$alert(result && result.message, "提示");
        }
      } catch (error) {
        console.log("创建分享链接-请求失败", error);
      }
    },

    /**
     * 显示-查看材料链接弹出层
     */
    seeLinks() {
      this.getLinks();
      this.linkListdialog = true;
    },

    /**
     * 隐藏-查看材料连接弹出层
     */
    hideLinkListdialog() {
      this.linkListdialog = false;
    },

    /**
     * 跳转页面-发送邮件通知
     */
    onNavsToSendEmail() {
      const { caseCode, flowCode } = this.caseInfo;
      this.$router.push(`/index/sendemail/${caseCode}/${flowCode}`);
    },

    /**
     * 显示抽屉盒
     */
    showdrawerbox(type) {
      this.$emit("showdrawerbox", type);
    },

    /**
     * 中转流程公共操作方法
     */
    async moveCase(operation, remark) {
      const _this = this;
      const { caseCode } = _this.caseInfo;
      const params = { caseCode, operation, remark };

      try {
        const { data: result } = await _this.axios.post(
          `/case-station/changeStation/`,
          params
        );

        if (result && result.status === "000000") {
          _this.$alert("操作成功", "提示", {
            callback: () => {
              _this.$emit("fetchCaseInfo");
            },
          });
        } else {
          _this.$alert(result && result.message, "提示");
        }
      } catch (error) {
        console.log("中转流程公共操作方法-请求失败", error);
      }
    },

    /**
     * 显示-历史处理记录-弹出窗
     */
    onShowHistoryDialog() {
      this.historyDialog = true;
    },

    /**
     * 隐藏-历史处理记录-弹出窗
     */
    onHideHistoryDialog() {
      this.historyDialog = false;
    },

    /**
     * 查看历史处理记录信息-备注-显示抽屉弹出窗
     * @param {Number} index 下标值
     */
    showHistory(index) {
      this.$emit("showHistory", index);
    },

    /**
     * 查看历史处理记录信息-告知规则备注-显示抽屉弹出窗
     * @param {Number} index 下标值
     */
    showRuleAnswerContent(index) {
      this.$emit("showRuleAnswerContent", index);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
